import  ClearButton from './clearButton';
import LogoutButton from './logoutButton';
import logo from '../../icon-1024.png'
import "./header.css";

import {ReactComponent as LindexLogo} from '../../logo.svg';

function Header(props){
    const { logout, clearChatLog } = props;

    
    
    return (
        <header className="header">
            <div className="header-left">
                <img className='copilot-logo' src={logo} alt="copilot logo" />
                <div>
                    <LindexLogo className='lindex-logo'/>
                    <p className='title'>Copilot</p>
                </div>
            </div>
            <div className="header-right">
                <LogoutButton logout={logout} />
                <ClearButton clear={clearChatLog} />
            </div>
        </header>
    );
}

export default Header;
